import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// personal

// const firebaseConfig = {
//   apiKey: "AIzaSyCNr_zuOSrNBTprF-EmWdaCvM7s3wayMOI",
//   authDomain: "khaanpinauthentication-a4f3e.firebaseapp.com",
//   projectId: "khaanpinauthentication-a4f3e",
//   storageBucket: "khaanpinauthentication-a4f3e.appspot.com",
//   messagingSenderId: "864863022147",
//   appId: "1:864863022147:web:0bed89722183ba67e078f6",
//   measurementId: "G-SQN5XFGQ75"
// };


// khaanpin 

const firebaseConfig = {
  apiKey: "AIzaSyCEf7ucigusuScmckE5yQGfkf31UP1_lW8",
  authDomain: "khaanpin-customer-facing.firebaseapp.com",
  databaseURL: "https://khaanpin-customer-facing.firebaseio.com",
  projectId: "khaanpin-customer-facing",
  storageBucket: "khaanpin-customer-facing.appspot.com",
  messagingSenderId: "859962524016",
  appId: "1:859962524016:web:ef1747fa51c210bf1dcfb5",
  measurementId: "G-YLBJH6EWXB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const authentication = getAuth(app);
